import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-job',
  templateUrl: './main-job.component.html',
  styleUrls: ['./main-job.component.css']
})
export class MainJobComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
